/**
 * @file Helpers for composeMetaTemplate component
 */

import { MessageStatus } from '../../../generated/graphql';

/**
 * Filter task templates for tasks, and post templates for posts
 *
 * @param dataStatusCurrent The status value from the compose form
 * @param nodes             Post/Task templates
 * @returns                 Template nodes
 */
export const filterTemplatesByComposeType = <
  T extends { status?: MessageStatus | null },
>(
  dataStatusCurrent: T['status'],
  nodes: T[] | undefined,
) => {
  return (
    nodes?.filter(node => (dataStatusCurrent ? node.status : !node.status)) ??
    []
  );
};
